import * as Yup from 'yup';

export const couponSchema = Yup.object({
  code: Yup.string().trim(),
});
